import { defaultRehypePlugins } from 'streamdown';
import type { MarkdownLinkSafety, MarkdownRehypePlugins } from './markdown.types';

export const MARKDOWN_LINK_SAFETY: MarkdownLinkSafety = { enabled: false };

export const MARKDOWN_REHYPE_PLUGINS: MarkdownRehypePlugins = [
  defaultRehypePlugins.sanitize,
  defaultRehypePlugins.harden,
];
